import type { ApolloClient, NormalizedCacheObject } from '@apollo/client/core';

const CONTAINER_TYPENAME = 'Container';

export function getApolloClientFromVm(vm: {
  $apollo?: {
    client?: ApolloClient<NormalizedCacheObject>;
    provider?: { defaultClient?: ApolloClient<NormalizedCacheObject> };
  };
}): ApolloClient<NormalizedCacheObject> | undefined {
  return vm.$apollo?.provider?.defaultClient ?? vm.$apollo?.client;
}

/** Keep normalized Container entities in sync when the list row is patched locally. */
export function writeContainerNotesToCache(
  client: ApolloClient<NormalizedCacheObject>,
  containerId: number | string,
  fields: { notes?: unknown[]; archivedNotes?: unknown[] },
): void {
  const cacheId = client.cache.identify({
    __typename: CONTAINER_TYPENAME,
    id: String(containerId),
  });
  if (!cacheId) {
    return;
  }

  client.cache.modify({
    id: cacheId,
    fields: {
      ...(fields.notes !== undefined && { notes: () => fields.notes }),
      ...(fields.archivedNotes !== undefined && {
        archivedNotes: () => fields.archivedNotes,
      }),
    },
  });
}

/** Keep normalized Container entities in sync when vessel ETA is patched locally. */
export function writeContainerEtaToCache(
  client: ApolloClient<NormalizedCacheObject>,
  containerId: number | string,
  eta: string,
): void {
  const cacheId = client.cache.identify({
    __typename: CONTAINER_TYPENAME,
    id: String(containerId),
  });
  if (!cacheId) {
    return;
  }

  client.cache.modify({
    id: cacheId,
    fields: {
      eta: () => eta,
    },
  });
}
